import React, { type FC, memo, type RefObject } from 'react';
import cn from 'clsx';
import { CVVHintButton, CVVImage } from '..';
import { DH } from '../../../../../utils/DataHook';
import s from '../styles.scss';
import { type CVVHintProps } from './types';

interface CVVHintViewProps extends CVVHintProps {
  isOpened: boolean;
  buttonRef: RefObject<HTMLButtonElement>;
  tooltipRef: RefObject<HTMLDivElement>;

  onButtonClick(): void;
  onMouseOver(): void;
  onMouseOut(): void;
}

export const CVVHintView: FC<CVVHintViewProps> = memo((props) => {
  return (
    <div className={s.cvvHelpContainer}>
      <CVVHintButton
        onMouseOver={props.onMouseOver}
        onMouseOut={props.onMouseOut}
        onClick={props.onButtonClick}
        ref={props.buttonRef}
      />
      <div
        className={cn(s.cvvTooltipContainer, {
          [s.visible]: props.isOpened,
        })}
        role="tooltip"
        aria-hidden={props.isOpened ? 'false' : 'true'}
        data-hook={DH.Field.CVVHint.Tooltip}
        data-is-visible={props.isOpened}
        onMouseOver={(e) => {
          if (!props.tooltipRef.current.contains(e.relatedTarget as HTMLElement)) {
            props.onMouseOver();
          }
        }}
        onMouseOut={(e) => {
          if (!props.tooltipRef.current.contains(e.relatedTarget as HTMLElement)) {
            props.onMouseOut();
          }
        }}
        ref={props.tooltipRef}
      >
        <div className={s.cvvTooltipArrow} />
        <div className={s.content}>
          <div id="cvv-help-text-default" className={s.cvvHelpText} aria-live="polite">
            {props.text}
          </div>
          <CVVImage src={props.cvvImageSrc} />
        </div>
      </div>
    </div>
  );
});
CVVHintView.displayName = 'CVVHintView';
